// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Mapping__container___e7Uf6 {
    display: flex;
    flex-direction: column;

    height: 100%;
    padding-top: 2.4rem;
    padding-left: 1.2rem;
}

.Mapping__spin___BMtWC {
    margin: auto;
}

.Mapping__tableArea___cYdyq {
    display: flex;
    gap: 2.5rem;
    height: 100%;
}

.Mapping__tableInformer___Gq4ke {
    align-self: flex-start;
    max-width: 30rem;
}

.Mapping__mappingText___wfent {
    padding-bottom: 0.8rem;
}
`, "",{"version":3,"sources":["webpack://./src/core/pages/Project/MasterImport/MarkersImport/Mapping/Mapping.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;;IAEtB,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n\n    height: 100%;\n    padding-top: 2.4rem;\n    padding-left: 1.2rem;\n}\n\n.spin {\n    margin: auto;\n}\n\n.tableArea {\n    display: flex;\n    gap: 2.5rem;\n    height: 100%;\n}\n\n.tableInformer {\n    align-self: flex-start;\n    max-width: 30rem;\n}\n\n.mappingText {\n    padding-bottom: 0.8rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Mapping__container___e7Uf6`,
	"spin": `Mapping__spin___BMtWC`,
	"tableArea": `Mapping__tableArea___cYdyq`,
	"tableInformer": `Mapping__tableInformer___Gq4ke`,
	"mappingText": `Mapping__mappingText___wfent`
};
export default ___CSS_LOADER_EXPORT___;
